import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { Grid2 as Grid, Typography, Button, Paper } from "@mui/material";
import {
  Donation,
  DefaultDonation,
  CodeDetails,
  Charity,
  Settings,
} from "../../../shared/types";
import { calculateCurrentDonationAmount } from "../../../shared/utilities/tools";
import {
  DonationInstructions,
  DonationAmount,
  DonationMessage,
  DirectAmount,
} from "../components";
import { isValidDonation } from "../../../shared/utilities/validators";
import * as consts from "../../../shared/utilities/consts";

export interface DonationInputsProps {
  codeDetails: CodeDetails;
  settings: Settings;
  charity: Charity;
  donations: Donation[];
  handleOpenCodeInputs: () => void;
  handleOpenCreditCardInputs: () => void;
  handleSubmit: (donation: Donation) => void;
}

export const DonationInputs = ({
  codeDetails,
  settings,
  charity,
  donations,
  handleOpenCodeInputs,
  handleOpenCreditCardInputs,
  handleSubmit,
}: DonationInputsProps): React.JSX.Element => {
  let currentDonationAmount = 0;
  donations.map((donation) => {
    if (donation.ein != charity.ein) {
      currentDonationAmount += donation.amount;
    }
  });

  const [donation, setDonation] = useState<Donation>({
    ...DefaultDonation,
    ein: charity.ein,
    name: charity.managed.displayName,
    amount:
      settings.donationDefault > -1
        ? settings.donationDefault
        : codeDetails.availableAmount - currentDonationAmount,
  });
  const [updating, setUpdating] = useState<boolean>(false);

  useEffect(() => {
    fetchDonation(charity.ein);
  }, []);

  const fetchDonation = (ein: string) => {
    let existingDonation = donations.find((item) => {
      return item.ein == ein;
    });
    if (existingDonation) {
      setDonation(existingDonation);
      setUpdating(true);
    }
  };

  const renderDonationType = () => {
    return (
      <Grid size={{ xs: 12 }}>
        <Paper sx={{ padding: "16px", maxWidth: "400px" }}>
          <Grid size={{ xs: 12 }} container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h4"
                style={{ textAlign: "center", paddingTop: "3px" }}
              >
                Show Your Support
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Button
                fullWidth={true}
                variant="outlined"
                onClick={() => {
                  handleOpenCodeInputs();
                }}
                className="tb_action_button"
              >
                Donate
              </Button>
            </Grid>
            {/* <Grid item xs={12}>
              <Button
                fullWidth={true}
                variant="outlined"
                onClick={() => {
                  handleOpenCreditCardInputs();
                }}
                className="tb_action_button"
              >
                Use a credit card to donate
              </Button>
            </Grid> */}
          </Grid>
        </Paper>
      </Grid>
    );
  };

  const renderCodeInputs = () => {
    return (
      <Grid size={{ xs: 12 }}>
        <Paper sx={{ padding: "16px" }}>
          <Grid size={{ xs: 12 }} container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h4"
                style={{ textAlign: "center", paddingTop: "3px" }}
              >
                Show Your Support
              </Typography>
            </Grid>
            <DonationAmount
              codeDetails={codeDetails}
              settings={settings}
              donation={donation}
              currentDonationAmount={calculateCurrentDonationAmount(
                donations,
                charity.ein
              )}
              handleChange={(updatedDonation: Donation) => {
                setDonation(updatedDonation);
              }}
            />
            <DonationMessage
              settings={settings}
              donation={donation}
              handleChange={(updatedDonation: Donation) => {
                setDonation(updatedDonation);
              }}
            />
            <DonationInstructions
              codeDetails={codeDetails}
              settings={settings}
              donation={donation}
              handleChange={(updatedDonation: Donation) => {
                setDonation(updatedDonation);
              }}
            />
            <Grid size={{ xs: 12 }}>
              <Button
                fullWidth={true}
                disabled={!isValidDonation(donation, settings)}
                variant="outlined"
                onClick={() => {
                  if (donation.amount >= settings.donationMinimum) {
                    handleSubmit(donation);
                  }
                }}
                className="tb_action_button"
              >
                {updating ? "Update" : "Add Charity"}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  };

  const renderDirectInputs = () => {
    return (
      <Grid size={{ xs: 12 }}>
        <Paper sx={{ padding: "16px" }}>
          <Grid size={{ xs: 12 }} container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h4"
                style={{ textAlign: "center", paddingTop: "3px" }}
              >
                Show Your Support
              </Typography>
            </Grid>
            <DirectAmount
              settings={settings}
              donation={donation}
              currentDonationAmount={calculateCurrentDonationAmount(
                donations,
                charity.ein
              )}
              handleChange={(updatedDonation: Donation) => {
                setDonation(updatedDonation);
              }}
            />
            <DonationMessage
              settings={settings}
              donation={donation}
              handleChange={(updatedDonation: Donation) => {
                setDonation(updatedDonation);
              }}
            />
            <DonationInstructions
              codeDetails={codeDetails}
              settings={settings}
              donation={donation}
              handleChange={(updatedDonation: Donation) => {
                setDonation(updatedDonation);
              }}
            />
            <Grid size={{ xs: 12 }}>
              <Button
                fullWidth={true}
                disabled={!isValidDonation(donation, settings)}
                variant="outlined"
                onClick={() => {
                  if (donation.amount >= settings.donationMinimum) {
                    handleSubmit(donation);
                  }
                }}
                className="tb_action_button"
              >
                {updating ? "Update" : "Add Charity"}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  };

  return (
    <Grid size={{ xs: 12 }} container spacing={2}>
      {codeDetails.valid
        ? codeDetails.code == consts.DIRECT_CODE
          ? renderDirectInputs()
          : renderCodeInputs()
        : renderDonationType()}
    </Grid>
  );
};
